import { createContext, useContext } from 'react';
const EMPTY_PERMISSIONS_CONTEXT = {
  hasScope: () => false,
  hasGate: () => false
};
export const PermissionsContext = /*#__PURE__*/createContext(EMPTY_PERMISSIONS_CONTEXT);
export const usePermissionsContext = () => useContext(PermissionsContext);